import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { variants } from '../../../variants/variants';

const ChatBubble = ({ isOwnMessage, chat }) => {
  const { message, edited } = chat;

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: isOwnMessage ? 'flex-start' : 'flex-end',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          borderRadius: 3,
          backgroundColor: isOwnMessage ? '#0A4FAC' : '#EEF5FF',
          padding: '8px 12px',
          maxWidth: { xs: '65vw', lg: '35vw' },
          width: 'auto',
          wordWrap: 'break-word',
          marginLeft: isOwnMessage ? 'auto' : 0,
          marginRight: isOwnMessage ? 0 : 'auto',
          borderTopRightRadius: isOwnMessage ? 0 : null,
          borderTopLeftRadius: isOwnMessage ? null : 0,
          boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        {edited && (
          <Tooltip title="This message has been edited">
            <Edit
              sx={{
                position: 'absolute',
                right: isOwnMessage ? null : 'calc(-20px)',
                left: isOwnMessage ? 'calc(-20px)' : null,
                color: 'grey',
                fontSize: '13px',
                transform: 'translateY(5px)',
              }}
            />
          </Tooltip>
        )}
        <Typography
          variant="body1"
          color={isOwnMessage ? 'white' : 'black'}
          fontSize={variants.BODY}
          sx={{
            whiteSpace: 'pre-wrap',
            '& a': {
              color: isOwnMessage ? 'white' : 'black',
            },
          }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </Box>
    </Box>
  );
};

export default ChatBubble;
